import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { useRef } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CodeDisplayer from "../../../../../../../common/CodeDisplayer";
import useTab from "../../../../hooks/useTab";
import {
  ItemContentContainer,
  ItemWrapper,
  StyledAGGrid,
  DBTHeaderContainer,
} from "../../../../style";
import TitleWrapper from "../../../TitleWrapper";
import { size } from "lodash";
import { brighthiveTheme } from "../../../../../../../theme/theme";

type Props = {
  output: any;
  index: number;
  isClosed: boolean;
  handleCollapse: (index: number) => () => void;
};

const DBTBlock = ({ output, index, isClosed, handleCollapse }: Props) => {
  const { animationStyles } = useTab({ isClosed });
  const gridRef = useRef<any>(null);

  const handleExportCSV = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsCsv({
        fileName: `dbt-transformation-${Date.now()}.csv`,
      });
    }
  };

  return (
    <ItemWrapper>
      <TitleWrapper
        title="DBT"
        handleCollapse={handleCollapse}
        index={index}
        animationStyles={animationStyles}
      />
      <ItemContentContainer sx={animationStyles.displayContainer}>
        {output?.sql && (
          <Box>
            <CodeDisplayer code={output.sql} />
          </Box>
        )}

        {size(output?.resulted_transformation) > 0 && (
          <>
            <DBTHeaderContainer>
              <Typography variant="body2" fontWeight="bold">
                Resulted Transformation
              </Typography>
              <Tooltip title="Export as CSV">
                <IconButton onClick={handleExportCSV} size="small">
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </DBTHeaderContainer>

            <Box
              sx={{ maxHeight: "25vh" }}
              onClick={(e) => e.stopPropagation()}
            >
              <StyledAGGrid
                ref={gridRef}
                className="ag-theme-material top-border-0"
                suppressContextMenu
                suppressMovableColumns
                suppressDragLeaveHidesColumns
                pagination
                headerHeight={40}
                rowHeight={40}
                domLayout="autoHeight"
                rowData={output?.resulted_transformation}
                columnDefs={Object.keys(output?.resulted_transformation[0]).map(
                  (key) => ({
                    field: key,
                  })
                )}
              />
            </Box>
          </>
        )}
      </ItemContentContainer>
    </ItemWrapper>
  );
};

export default DBTBlock;
